const [viewMoreButton, viewLessButton] = [document.querySelector('[data-gallery-view-more]'), document.querySelector('[data-gallery-view-less]')];
const galleryThumbnails = document.querySelectorAll('.image-limit');

const toggleImages = (hide) => {
    galleryThumbnails.forEach(thumbnail => thumbnail.classList.toggle('hide-image', hide));
    viewMoreButton.classList.toggle('no-js', !hide);
    viewLessButton.classList.toggle('no-js', hide);
    // smooth scroll to top when click view less
    if (hide) document.getElementById('MainContent').scrollIntoView({ behavior: 'smooth' });
};

viewMoreButton.addEventListener('click', () => toggleImages(false));
viewLessButton.addEventListener('click', () => toggleImages(true));
